/**
 * @generated SignedSource<<cf0c145e6f9bbb0b052e8e38b308d079>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HistoryRefetchQuery$variables = {
  id: string;
};
export type HistoryRefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"HistoryCharts_history">;
  } | null;
};
export type HistoryRefetchQuery = {
  variables: HistoryRefetchQuery$variables;
  response: HistoryRefetchQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cents",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formatted",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "MoneyAmount",
  "kind": "LinkedField",
  "name": "amount",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v6 = [
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "label",
    "storageKey": null
  },
  (v5/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HistoryRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "HistoryCharts_history"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HistoryRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MoneyAmount",
                "kind": "LinkedField",
                "name": "earningTotal",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MoneyAmount",
                "kind": "LinkedField",
                "name": "cashoutTotal",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "HistoryTotalAmount",
                "kind": "LinkedField",
                "name": "earningBreakdown",
                "plural": true,
                "selections": (v6/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "HistoryTotalAmount",
                "kind": "LinkedField",
                "name": "cashoutBreakdown",
                "plural": true,
                "selections": (v6/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "HistoryMonthlyAmount",
                "kind": "LinkedField",
                "name": "monthlyEarnings",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "date",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "History",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "927c26bc0f216325d6238ab618766186",
    "id": null,
    "metadata": {},
    "name": "HistoryRefetchQuery",
    "operationKind": "query",
    "text": "query HistoryRefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...HistoryCharts_history\n    id\n  }\n}\n\nfragment HistoryCharts_history on History {\n  id\n  status\n  earningTotal {\n    cents\n    formatted\n  }\n  cashoutTotal {\n    formatted\n  }\n  earningBreakdown {\n    type\n    label\n    amount {\n      cents\n      currency\n      formatted\n    }\n  }\n  cashoutBreakdown {\n    type\n    label\n    amount {\n      cents\n      currency\n      formatted\n    }\n  }\n  monthlyEarnings {\n    date\n    type\n    amount {\n      cents\n      currency\n      formatted\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e152ee58d93ea3ded6a8788580477103";

export default node;
